import { useState } from 'react';

/**
 * Returns true when the POS is running inside the ReachPro native app WebView.
 *
 * Two signals are checked so detection is reliable regardless of timing:
 *  1. window.__REACHPRO_NATIVE__ — explicitly injected via
 *     injectedJavaScriptBeforeContentLoaded in NativeNavWebView, guaranteed to
 *     be present before any JavaScript (including React) runs.
 *  2. window.ReactNativeWebView — set automatically by react-native-webview's
 *     native bridge; present in all WebView contexts as a fallback.
 *
 * useState (lazy initialiser) is used so the check runs exactly once at mount
 * time rather than on every render, and is never affected by SSR / pre-render
 * passes where window is undefined.
 */
export function useIsNativeApp(): boolean {
  const [isNative] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return (
      (window as any).__REACHPRO_NATIVE__ === true ||
      'ReactNativeWebView' in window
    );
  });
  return isNative;
}
